import { Layout } from "@/components/layout/Layout";
import { SEO } from "@/components/SEO";
import { Button } from "@/components/ui/button";

const CookiePolicy = () => {
  const openPreferences = () => {
    window.dispatchEvent(new CustomEvent("open-cookie-preferences"));
  };

  return (
    <Layout>
      <SEO
        title="Cookie Policy | Bookkeeping Services South Africa"
        description="How we use cookies on bookkeepingservices.co.za, the categories we set, and how to manage your preferences under POPIA."
        canonical="/cookie-policy"
      />
      <section className="py-16 lg:py-24 section-accent">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto text-center">
            <h1 className="font-heading text-4xl md:text-5xl font-bold text-foreground mb-6">
              Cookie Policy
            </h1>
            <p className="text-lg text-muted-foreground">Last updated: July 2026</p>
          </div>
        </div>
      </section>

      <section className="py-16 lg:py-24 section-white">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto space-y-8">
            <p>
              This Cookie Policy explains how Bookkeeping Services South Africa uses cookies and
              similar technologies on bookkeepingservices.co.za. It should be read alongside our
              Privacy Policy and complies with the Protection of Personal Information Act (POPIA).
            </p>

            <div>
              <h2 className="font-heading text-2xl font-semibold mb-3">What are cookies?</h2>
              <p>
                Cookies are small text files stored on your device when you visit a website. They
                help the site function, remember your preferences, and provide usage insights.
              </p>
            </div>

            <div>
              <h2 className="font-heading text-2xl font-semibold mb-3">Categories we use</h2>
              <ul className="list-disc pl-6 space-y-2">
                <li>
                  <strong>Strictly necessary</strong> — required for the site to function (session,
                  security, cookie preference storage). Always on.
                </li>
                <li>
                  <strong>Analytics</strong> — Google Analytics, to understand how visitors use the
                  site so we can improve it.
                </li>
                <li>
                  <strong>Marketing</strong> — Google Ads conversion tracking, to measure the
                  effectiveness of our advertising.
                </li>
              </ul>
            </div>

            <div>
              <h2 className="font-heading text-2xl font-semibold mb-3">Your choices</h2>
              <p>
                Analytics and marketing cookies are disabled by default. You can accept all optional
                cookies or reject optional cookies through the consent banner, and change your choice
                at any time below.
              </p>
              <div className="mt-4">
                <Button onClick={openPreferences}>Change cookie choice</Button>
              </div>
            </div>

            <div>
              <h2 className="font-heading text-2xl font-semibold mb-3">Contact</h2>
              <p>
                Questions about this policy can be sent to{" "}
                <a href="mailto:info@bookkeepingservices.co.za" className="underline">
                  info@bookkeepingservices.co.za
                </a>
                .
              </p>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default CookiePolicy;
